










































import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import _ from "lodash";
import { User } from "front-component/modules/User";
import { AllocationType } from "@/modules/budget/AllocationType";
import AllocationTypeRepository from "@/repositories/budget/AllocationTypeRepository";

@Component
export default class AllocationTypeEdit extends Vue {
    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getCurrentUser") public user!: User;
    @Getter("getAllocationTypes") public allocationTypes!: AllocationType[];
    @Getter("getUserDepartment") public userDepartment!: string;
    @Action("loadAllocationTypes") public loadAllocationTypes: any;

    private allocationUuid: string | null = null;
    private allocationEditing: boolean = false;
    private allocationTypeEdit: string = "";

    private addAllocationType(): void {
        this.allocationEditing = true;
        this.allocationUuid = null;
    }

    private editAllocation(uuid: string): void {
        this.allocationUuid = uuid;
        this.allocationEditing = true;
        const allocationType = _.find(this.allocationTypes, (allocType) => {
            return allocType.uuid === uuid;
        });
        this.allocationTypeEdit = _.get(allocationType, "label", "");
    }

    private saveAllocationType(): void {
        const allocationType = {
            label: this.allocationTypeEdit,
            uuid: this.allocationUuid,
            owner: {
                uuid: this.ownerUuid,
            },
        };

        AllocationTypeRepository.save(allocationType).then((data) => {
            this.loadAllocationTypes();
            this.allocationUuid = "";
            this.allocationEditing = false;
        });
    }

    public get allocations(): AllocationType[] {
        return _.filter(this.allocationTypes, (allocationType: AllocationType) => {
            return allocationType.owner.uuid === this.ownerUuid;
        });
    }
}
